import { useState, useEffect } from "react";
import "./css/CookieBanner.css";

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = false;
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="texto_cookie">
    <div className="fixed bottom-0 left-0 w-full bg-gray-800 text-white p-4 z-50">
      <div className="d-flex items-center justify-content-center">
        <p>
        Usamos cookies para mejorar tu experiencia. Solo se guardan datos esenciales para el funcionamiento del sitio. Si inicias sesión, se almacenan cookies para interactuar con nuestra API. Consulta nuestra Política de Cookies para más información.
        </p>
        <button
          onClick={handleAccept}
          className="boton_cookie"
        >
          Acepto las cookies
        </button>
      </div>
    </div>
    </div>
  );
}

export default CookieBanner;
